import React from 'react';
import { allAppsWidth } from '../../Common/ReportsTableSummary';
import ReportSummaryOverview from '../../Common/ReportSummaryOverview';
import { getReportColumnsForSeries } from '../SalesOrEvaluations.utils';
import { headerConfigBasedOnReportBy } from '../SalesOrEvaluationsTable/SalesOrEvaluationsTableHead';
export default function SalesOrEvaluationsSummary(props) {
  const {
    totalSeries,
    reportBy,
    reportName,
    period,
    LinePatternMapper
  } = props;
  const reportMeta = {
    reportName,
    period
  };
  const reportColumns = getReportColumnsForSeries({
    series: totalSeries.series,
    reportName,
    reportBy,
    isSummaryContent: true
  });
  const summary = [];
  const headersConfig = [...headerConfigBasedOnReportBy[reportBy], "All ".concat(reportName)];
  headersConfig.map((head, index) => {
    const summaryHead = reportBy === 'country' ? reportColumns[index].name : head;
    const color = reportBy === 'country' ? LinePatternMapper(reportColumns[index].country).color : LinePatternMapper(head).color;
    return summary.push({
      color,
      head: summaryHead,
      content: reportColumns[index].content,
      width: "".concat((100 - allAppsWidth) / reportColumns.length, "%")
    });
  });
  return /*#__PURE__*/React.createElement(ReportSummaryOverview, {
    summary: summary,
    reportMeta: reportMeta
  });
}